import $ from 'jquery';

export default class Accordion {
  constructor() {
    this.modifyDOM();
    this.addEvents();
  }

  addEvents() {
    $(document).on('click', '.accordion__header', this.toggleAccordion);
  }

  modifyDOM() {
  }

  toggleAccordion(e) {
    $(e.target).closest('.accordion').toggleClass('active');
  }
}
